/* eslint-disable */
import styled from 'styled-components';

import { WatermarkedTableContainer } from 'components/WatermarkedTableContainer';
import { Wrapper as TooltipWrapper } from 'components/Tooltip/styles';

import {
  colorGrey400,
  colorBlack900,
  fontFamilyPrimary,
  colorPrimary,
  colorWhite2,
  mediaQueryMobileLargeMin, colorAccent, fontFamilySecondary
} from "styles";
import { Link } from "react-router-dom";

export const Wrapper = styled(WatermarkedTableContainer)`
  font-family: ${fontFamilyPrimary};
`;

export const PlainWrapper = styled.div`
  font-family: ${fontFamilyPrimary};
`;

export const TableWrapper = styled.table`
  width: 100%;
`;

export const TableHeader = styled.thead`
  & tr {
    height: 24px;
    background: #fff;   
    box-shadow: inset 0px -1px 0px #e6e6e6;
  }
`;

export const Title = styled.th`
  color: ${colorGrey400};
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;

  &:first-child {
    text-align: left !important;
  }
  ${({ type }) =>
    type === 'nbu' &&
    ` 
      &:last-child {
        text-align: end;
      }
    `
}

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 6px;

    &:last-child {
      text-align: start;
    }
  }
`;

export const Row = styled.tr`
  height: 48px;
  text-align: -webkit-left;
  box-shadow: inset 0px -1px 0px #e6e6e6;
  &:nth-child(even) {
    background: #fbfbfb;
  }
 
  & td:first-child,
  & th:first-child {
    padding-left: 8px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    & td:first-child,
    & th:first-child {
      padding-left: 16px;
    }
  }
`;

export const Code = styled.td`
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900}; 

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 16px;
    line-height: 28px;
  }

  ${({ anotherCurrTable }) =>
    anotherCurrTable &&
    `width: 60px;`
  }
`;

export const Currency = styled.td`
  width: unset;

  @media all and ${mediaQueryMobileLargeMin} {
    width: 15%;
  }

  ${({ type }) => {
    if (type = 'mb') {
      return `
      width: 33%;
        @media all and ${mediaQueryMobileLargeMin} {
          width: 33%;
        }
      `;
    }

    return '';
  }}
`;

export const CurrencyLink = styled(Link)`
  color: ${({ isActive }) => (isActive ? colorBlack900 : colorWhite2)};
  pointer-events: ${({ isActive }) => (isActive ? 'none' : 'auto')};
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  padding: 0;
  margin: 0;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    font-size: 18px;
  }

  ${({ anotherCurrTable }) =>
    anotherCurrTable &&
    ` 
    width: 44px;
`}
`;

export const Curr = styled.td`
  font-size: 18px;
  line-height: 21px;
  font-weight: 900;

  ${({ anotherCurrTable }) =>
    anotherCurrTable &&
    ` 
    width: 0;

    @media all and ${mediaQueryMobileLargeMin} {
      width: 180px;
    }
  `}
`;
export const CurrContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 19px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    font-size: 18px;
    line-height: 21px;
  }

  ${({ type }) =>
    type === 'nbu' &&
    ` 
      align-items: flex-end;

      @media all and ${mediaQueryMobileLargeMin} {
        align-items: unset;
      }
  `}
`;

export const CurrName = styled.td`
  font-size: 14px;
  line-height: 18px;
  color: ${colorBlack900};

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 16px;
    line-height: 28px;
  }

  ${({ anotherCurrTable }) =>
    anotherCurrTable &&
    ` 
  width: 249px;
`}
`;


export const DiffWrapper = styled.div`
  display: flex;
  margin-top: 2px;
  
  & > ${TooltipWrapper} {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  &:hover > ${TooltipWrapper} {
    visibility: visible;
    opacity: 1;
  }

  & svg {
    margin-top: ${({ fall }) => (fall ? '2px' : '1px')};
  }

  @media all and ${mediaQueryMobileLargeMin} { 
    margin-left: 4px;
    margin-top: 8px;
  }
`;

export const Diff = styled.p`
  font-weight: normal;
  font-size: 11px;
  line-height: 9px;
  color: ${colorGrey400};
  margin-left: 2px;
`;

export const Button = styled.button`
  color: #fff;
  background: ${colorPrimary};
  line-height: 32px;
  height: 32px;
  font-size: 14px;
  padding: 0 16px;
  border: none;
  border-radius: 2px;
  margin-left: auto;
  font-family: ${fontFamilySecondary};
  font-weight: bold;
  display: inline-block;
  transition: 0.3s opacity;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  width: 100%;

  ${({ anotherCurrTable }) =>
    anotherCurrTable &&
    `flex-direction: row-reverse;`
  }

  ${({ type }) => {
    if (type === 'mb') {
      return `justify-content: flex-start;`
    }
  }}
`;
